'use client';

import selectEnergyLabelInformationTriggerComparisonTool from '@coolblue-development/ga4-events/triggers/ComparisonTool/selectEnergyLabelInformationTrigger';
import showEnergyLabelTriggerComparisonTool from '@coolblue-development/ga4-events/triggers/ComparisonTool/showEnergyLabelTrigger';
import selectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/selectEnergyLabelInformationTrigger';
import showEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/showEnergyLabelTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import EnergyLabelComponent, {
  type EnergyLabelProps
} from '@coolblue-development/next-energy-label/client';
import type { EnergyLabelType } from '@features/product/typings';

export default function EnergyLabel({
  energyLabel,
  trackingFeatureName,
  direction,
  size,
  bypassSubsidiaryCheck = false
}: {
  energyLabel: EnergyLabelType;
  trackingFeatureName?: 'item_card' | 'comparison_tool';
  direction?: EnergyLabelProps['direction'];
  size?: EnergyLabelProps['size'];
  bypassSubsidiaryCheck?: boolean;
}) {
  const { trackEvent } = useAnalytics();

  if (!energyLabel) return <></>;

  const triggerEvents = {
    item_card: {
      show: showEnergyLabelTrigger,
      click: selectEnergyLabelInformationTrigger
    },
    comparison_tool: {
      show: showEnergyLabelTriggerComparisonTool,
      click: selectEnergyLabelInformationTriggerComparisonTool
    }
  };

  const onShow = () => {
    if (trackingFeatureName) {
      trackEvent(triggerEvents[trackingFeatureName].show());
    }
  };

  const onContentClick = () => {
    if (trackingFeatureName) {
      trackEvent(
        triggerEvents[trackingFeatureName].click({ content: 'product_information_sheet' })
      );
    }
  };

  return (
    <EnergyLabelComponent
      direction={direction}
      size={size}
      level={energyLabel.level}
      version={energyLabel.version}
      bypassSubsidiaryCheck={bypassSubsidiaryCheck}
      {...(energyLabel.image?.id && { imageId: Number(energyLabel.image.id) })}
      {...(energyLabel.version !== 'legacy' &&
        energyLabel.specification?.absoluteUrl && {
          specificationUrl: energyLabel.specification.absoluteUrl
        })}
      onContentClick={trackingFeatureName ? onContentClick : undefined}
      onShow={trackingFeatureName ? onShow : undefined}
    />
  );
}
